// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".order-detail .el-collapse-item__header {\n  padding: 0 15px;\n  border-bottom: none;\n  color: #4283ff;\n  font-weight: bold;\n  background-color: #fff;\n}\n.order-detail .el-collapse-item__wrap {\n  padding: 15px;\n  border-bottom: none;\n  background-color: #f0f3f8 !important;\n}\n.order-detail .el-collapse-item__arrow {\n  color: #303133;\n}\n", ""]);
// Exports
module.exports = exports;
